import React from 'react';
import useDataLoader2 from '../../hooks/useDataLoader2';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import { UseRegionList } from '../../hooks/Catalogs/useRegionListOptions';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import { ICountry } from '../../interfaces';
import { formatTimeSpanToString } from '../../utils/functions';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const Country: React.FC = ({ ...props }) => {
  const { regionData } = UseRegionList();
  const fields = [
    'id',
    'legacyId',
    'name',
    'hasState', 
    'abbreviation', 
    'regions', 
    'regionNames', 
    'createdDate'
  ]
  const endpoint = '/country';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    inputFilters,
    setInputFilters,
    filter
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    { 
      id: 'count', 
      header: '#', 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>{rowIndex + 1 + pagination.pageIndex * pagination.pageSize}</p>
      )
    },
    { id: 'name', header: 'Name' },
    { id: 'abbreviation', header: 'Abbreviation' },
    { id: 'hasState', header: 'Has State' },
    { id: 'region', header: 'Regions' },
    { id: 'createdDate', header: 'Created Date' },
    {
      id: 'edit', 
      header: 'Edit', 
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg"><ShapeEdit /></div>
        </PersistentLink>
      )
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);

  const formatData = (data: ICountry[]) => { 
    const formatedData = data.map((d: ICountry) => {
        return {
          ...d,
          hasState: d.hasState ? 'Yes' : 'No',
          region: d.regionNames,
          createdDate: d.createdDate && formatTimeSpanToString(d.createdDate),
        };
    })
    return formatedData;
  }
  
  const filtersData: IFilterData[] = React.useMemo(() => [
      {
        name: "Name",
        type: "text",
        comparison: "CONTAINS",
      },
      {
        name: "Region",
        fieldName: "regions",
        objectData: regionData?.map((r: any) => ({id: r.id, name: r.name})) || [],
        comparison: 'ARRAY_SEARCH_ID'
      },
      {
        name: "Abbreviation",
        type: "text",
        comparison: "CONTAINS",
      },
    ], [regionData]);
    
  return (
    <>
      <div>
          <CatalogTableC
            title={`Country Catalog`}
            catalogName={'COUNTRIES'}
            catalogShortName={'COUNTRY'}
            route={'Country'}
            totalCount={totalCount}
          >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
          </CatalogTableC>
        </div>
    </>
  );
};

export default Country;